import React, {Fragment} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import MaterialsIcons from "../../Icons/MaterialsIcons";
import {TRANSACTION_STATUSES} from "./jobPaymentReducer";


const JobPaymentPopupFinal = (props) => {

  const {paymentTotal, jobTotal, paymentStatus} = props;
  const remainingPayment = (Math.round((jobTotal - paymentTotal) * 100) / 100).toFixed(2);
  const isError = paymentStatus && paymentStatus.status === TRANSACTION_STATUSES.Error;

  const downloadInvoiceClick = () => {
    console.log("invoice");
  }

  return (
    <div className="job-payment__content relative job-payment__container flex flex--center flex--column">
      <div className={"job-payment__status flex flex--center" + (isError ? " job-payment__status--error" : "")}>
        <FormattedMessage id={isError ? "paymentPopup.statuses.paymentError" : "paymentPopup.statuses.paymentSuccess"}/>
      </div>
      <div className="job-payment__order-id">
        <FormattedMessage id="paymentPopup.orderId"/>: {paymentStatus ? paymentStatus.transactionId : "--"}
      </div>
      <p className={"job-payment__title " + (isError ? "color-red3" : "color-charcoal")}>
        <FormattedMessage id={isError ? "paymentPopup.errorTitle" : "paymentPopup.finalTitle"}/>
      </p>
      <p className={"job-payment__text job-payment__container margin-b16 margin-t0 text-center "
        + (isError ? "color-red3" : "color-charcoal")}>
        <FormattedMessage id={isError ? "paymentPopup.errorText" : "paymentPopup.finalText"}/>
      </p>
      {isError ? (
        <p className="job-payment__text job-payment__container text-center color-red3">
          {paymentStatus && paymentStatus.errorMessage ? paymentStatus.errorMessage : "Server error message here"}
        </p>
      ) : (
        <Fragment>
          <div className={"job-payment__text job-payment__container text-center flex flex--evenly color-gray4"}>
            <span><FormattedMessage id="paymentPopup.orderId"/>: --</span>
            <span><FormattedMessage id="paymentPopup.payment"/>: ${paymentTotal}</span>
          </div>
          <div className="text-center margin-t24">
            <button className="ui-button5 ui-button5--13 ui-button5--flex ui-button5--flex-icon-left text-uppercase
        ui-button5--flex-icon-left--small ui-button5--gray-border"
                    onClick={downloadInvoiceClick}>
              <span className="ui-button5__material-icon">{MaterialsIcons.DownloadIcon}</span>
              <FormattedMessage id="paymentPopup.saveInvoiceButton"/>
            </button>
          </div>
        </Fragment>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {paymentTotal, paymentStatus, jobTotal} = store.jobPaymentState;

  return {
    paymentTotal,
    paymentStatus,
    jobTotal,
  };
};

const mapDispatchToProps = {
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPaymentPopupFinal)
)
